/* NM · Anadir a la cesta en tarjetas de coleccion y buscador · AJ2 · v3 */
/* Traslada el formulario nativo del tema desde el <figure> (donde queda comido */
/* por la caja de la imagen) al cuerpo de la tarjeta, y le pone el texto real.  */
/* Solo actua dentro de la parrilla de productos; nunca fuera de la tarjeta.    */
(function () {
  if (!/template-(collection|search)/.test(document.body.className)) return;

  var raf = null;

  function cards() {
    return document.querySelectorAll('.l4cl > .product-card, #collection > .product-card');
  }

  function labelOf(card) {
    var src = card.querySelector('.link-btn.quickshop a .hidden');
    var txt = src ? src.textContent.trim() : '';
    return txt || 'Añadir a la cesta';
  }

  function host(card) {
    return card.querySelector('div.static') || card.querySelector(':scope > div') || card;
  }

  function place(card) {
    var form = card.querySelector('figure form.f8pr');
    if (form) {
      var target = host(card);
      if (target && form.parentNode !== target) target.appendChild(form);
      form.classList.add('nm-qa');
      return;
    }
    var out = card.querySelector('figure .link-btn:not(.quickshop)');
    if (out) {
      var t2 = host(card);
      if (t2 && out.parentNode !== t2) t2.appendChild(out);
      out.classList.add('nm-qa-out');
    }
  }

  function label(card) {
    var b = card.querySelector('form.f8pr.nm-qa .submit > button');
    if (!b || b.dataset.nmTxt === '1') return;
    var span = b.querySelector('span');
    if (!span) {
      span = document.createElement('span');
      while (b.firstChild) span.appendChild(b.firstChild);
      b.appendChild(span);
    }
    if (span.textContent.trim() === '') {
      span.innerHTML = '<i aria-hidden="true" class="icon-cart"></i>' +
        '<span class="nm-qa-l">' + labelOf(card) + '</span>';
    }
    b.dataset.nmTxt = '1';
  }

  function run() {
    raf = null;
    var list = cards();
    for (var i = 0; i < list.length; i++) {
      place(list[i]);
      label(list[i]);
    }
  }

  function queue() {
    if (!raf) raf = requestAnimationFrame(run);
  }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', queue);
  window.addEventListener('load', queue);

  var grid = document.querySelector('.l4cl') || document.getElementById('collection');
  if (grid && window.MutationObserver) {
    new MutationObserver(queue).observe(grid, { childList: true, subtree: true });
  }
})();
